import * as React from "react";
import { GetToken } from "../../components/Session";
import configData from "../../config.json";

const DashboardCards = ({ period }) => {
    const [weigh, setWeigh] = React.useState(null);
    const [previousWeight, setPreviousWeight] = React.useState(null);
    const [previousFinalWeight, setPreviousFinalWeight] = React.useState(null);
    const [transactions, setTransactions] = React.useState(null);
    const [previousTransactions, setPreviousTransactions] = React.useState(null);
    const [previousFinalTransactions, setPreviousFinalTransactions] = React.useState(null);
    const [sales, setSales] = React.useState(null);
    const [previousSales, setPreviousSales] = React.useState(null);
    const [previousFinalSales, setPreviousFinalSales] = React.useState(null);
    const [average, setAverage] = React.useState(null);
    const [previousAverage, setPreviousAverage] = React.useState(null);
    const [previousFinalAverage, setPreviousFinalAverage] = React.useState(null);

    let thisPeriod = "";
    let lastPeriod = "";
    let heading;

    switch (period) {
        case "financial":
            thisPeriod = "This financial year-to-Date";
            lastPeriod = "Previous financial year";
            heading = "Financial";
            break;
        case "yearly":
            thisPeriod = "Year-to-Date";
            lastPeriod = "Previous Year";
            heading = "Yearly";
            break;
        case "Monthly":
            thisPeriod = "Month-to-Date";
            lastPeriod = "Previous month";
            heading = "Monthly";
            break;
        case "weekly":
            thisPeriod = "Week-to-Date";
            lastPeriod = "Previous week";
            heading = "Weekly";
            break;
        default:
            thisPeriod = "Today";
            lastPeriod = "Yesterday";
            heading = "Daily";
    }

    React.useEffect(() => {
        const baseUrl = `${configData.SERVER_URL}apiV7/dashboard/getsummaryforperiod?period=${period}`;
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { Authorization: "Bearer " + GetToken() },
        };
        fetch(baseUrl, init)
            .then((response) => response.json())
            .then((d) => {
                setWeigh(d.weight);
                setPreviousWeight(d.previousWeight);
                setPreviousFinalWeight(d.previousFinalWeight);
                setTransactions(d.transactions);
                setPreviousTransactions(d.previousTransactions);
                setPreviousFinalTransactions(d.previousFinalTransactions);
                setSales(d.sales);
                setPreviousSales(d.previousSales);
                setPreviousFinalSales(d.previousFinalSales);
                setAverage(d.average);
                setPreviousAverage(d.previousAverage);
                setPreviousFinalAverage(d.previousFinalAverage);
            });
    }, [period]);

    const getTrendData = (current, previous) => {
        if (current == null || previous == null || previous === 0) return null;
        const change = current - previous;
        return { change };
    };

    const cardsData = [
        {
            title: `${heading} Net Weight`,
            currentLabel: thisPeriod,
            currentValue: weigh,
            previousLabel: `${lastPeriod} at this point`,
            previousValue: previousWeight,
            totalLabel: lastPeriod,
            totalValue: previousFinalWeight,
            unit: "t",
            color: "#4caf50",
            bgColor: "#e8f5e9",
            icon: "⚖️",
        },
        {
            title: "No of Transactions",
            currentLabel: thisPeriod,
            currentValue: transactions,
            previousLabel: `${lastPeriod} at this point`,
            previousValue: previousTransactions,
            totalLabel: `${lastPeriod} Total`,
            totalValue: previousFinalTransactions,
            unit: "",
            color: "#2196f3",
            bgColor: "#e3f2fd",
            icon: "🧾",
        },
        {
            title: "Sales",
            currentLabel: thisPeriod,
            currentValue: sales,
            previousLabel: `${lastPeriod} at this point`,
            previousValue: previousSales,
            totalLabel: `${lastPeriod} Total`,
            totalValue: previousFinalSales,
            unit: "",
            color: "#ff9800",
            bgColor: "#fff3e0",
            icon: "💰",
        },
        {
            title: "Average $/t",
            currentLabel: thisPeriod,
            currentValue: average,
            previousLabel: `${lastPeriod} at this point`,
            previousValue: previousAverage,
            totalLabel: `${lastPeriod} Total Average Weight`,
            totalValue: previousFinalAverage,
            unit: "",
            color: "#9c27b0",
            bgColor: "#f3e5f5",
            icon: "📊",
        },
    ];

    return (
        <>
            <style>{`
        .dashboard-container {
          display: flex;
          flex-wrap: nowrap; /* force one row */
          gap: 12px;
          padding: 20px 10px;
          overflow-x: auto; /* horizontal scroll if narrow */
          -webkit-overflow-scrolling: touch;
        }
        .dashboard-container::-webkit-scrollbar {
          height: 8px;
        }
        .dashboard-container::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .dashboard-container::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 10px;
        }
        .dashboard-card {
          flex: 0 0 24%; /* about 1/4th minus gaps */
          background-color: white;
          border-radius: 12px;
          box-shadow: 0 6px 15px rgba(0,0,0,0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: default;
          display: flex;
          flex-direction: column;
          padding: 25px 20px;
          user-select: none;
          min-width: 280px; /* prevent too narrow cards */
          box-sizing: border-box;
        }
        .dashboard-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 25px rgba(0,0,0,0.2);
        }
        .card-title {
          font-weight: 700;
          font-size: 1.3rem;
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          gap: 10px;
          color: #333;
          user-select: text;
        }
        .card-icon {
          font-size: 1.8rem;
        }
        .label {
          font-weight: 600;
          color: #555;
          font-size: 0.9rem;
          margin-top: 10px;
          margin-bottom: 6px;
          user-select: text;
        }
        .value {
          font-weight: 700;
          font-size: 1.9rem;
          color: var(--color);
          user-select: text;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .unit {
          font-weight: 400;
          font-size: 1.1rem;
          color: var(--color);
          margin-left: 5px;
        }
        .trend-arrow {
          font-size: 1.4rem;
          user-select: none;
        }
        .trend-up {
          color: #4caf50;
        }
        .trend-down {
          color: #f44336;
        }
        /* On super narrow screens, horizontal scroll will appear instead of wrapping */
        @media (max-width: 1000px) {
          .dashboard-card {
            min-width: 260px;
          }
        }
      `}</style>
            <div className="dashboard-container" role="list" aria-label="Dashboard Summary Cards">
                {cardsData.map(
                    ({
                        title,
                        currentLabel,
                        currentValue,
                        previousLabel,
                        previousValue,
                        totalLabel,
                        totalValue,
                        unit,
                        color,
                        bgColor,
                        icon,
                    }) => {
                        const trend = getTrendData(currentValue, previousValue);
                        const isUp = trend && trend.change > 0;

                        return (
                            <div
                                key={title}
                                className="dashboard-card"
                                style={{ "--color": color, backgroundColor: bgColor }}
                                aria-label={`${title} card`}
                                role="listitem"
                                tabIndex={0}
                            >
                                <div className="card-title">
                                    <span className="card-icon" aria-hidden="true">{icon}</span>
                                    {title}
                                </div>
                                <div>
                                    <div className="label">{currentLabel}</div>
                                    <div className="value" style={{ color }}>
                                        {currentValue ?? "-"}
                                        {unit && <span className="unit">{unit}</span>}
                                        {trend && (
                                            <span
                                                className={`trend-arrow ${isUp ? "trend-up" : "trend-down"
                                                    }`}
                                                aria-label={isUp ? "Trending up" : "Trending down"}
                                                role="img"
                                            >
                                                {isUp ? "▲" : "▼"}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div className="label">{previousLabel}</div>
                                    <div className="value">
                                        {previousValue ?? "-"}
                                        {unit && <span className="unit">{unit}</span>}
                                    </div>
                                </div>
                                <div>
                                    <div className="label">{totalLabel}</div>
                                    <div className="value">
                                        {totalValue ?? "-"}
                                        {unit && <span className="unit">{unit}</span>}
                                    </div>
                                </div>
                            </div>
                        );
                    }
                )}
            </div>
        </>
    );
};

export default DashboardCards;
